var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M510.977,250.975C467.408,148.537,367.321,82.344,256,82.344S44.594,148.535,1.023,250.975 c-1.364,3.206-1.364,6.827,0,10.033C44.591,363.458,144.677,429.656,256,429.656c111.326,0,211.411-66.198,254.977-168.648 C512.341,257.802,512.341,254.181,510.977,250.975z M256,404.022c-99.194,0-188.557-57.922-229.191-148.029 c40.635-90.098,130-148.014,229.191-148.014c99.193,0,188.557,57.916,229.191,148.012 C444.557,346.098,355.194,404.022,256,404.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,157.825c-54.134,0-98.174,44.041-98.174,98.174c0,54.133,44.041,98.174,98.174,98.174 c54.133,0,98.174-44.04,98.174-98.174C354.174,201.865,310.133,157.825,256,157.825z M256,328.541 c-39.998,0-72.54-32.542-72.54-72.54s32.542-72.54,72.54-72.54s72.54,32.542,72.54,72.54S295.998,328.541,256,328.541z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,203.878c-28.739,0-52.123,23.382-52.123,52.123c0,7.078,5.737,12.817,12.817,12.817 c7.08,0,12.817-5.739,12.817-12.817c0-14.606,11.882-26.489,26.489-26.489c7.08,0,12.817-5.739,12.817-12.817 C268.817,209.615,263.078,203.878,256,203.878z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.3784894f7223d1643303bdccac408386.svg";
export { ForwardRef as ReactComponent };